import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";

const authApi = 'auth';

export default {
    methods: {
        async getLogin() {
                const url = `${baseURL}${authApi}`
                const response = await this.httpSession.get(url)
                return response.data;
        },
        async postLogin(data) {
                const url = `${baseURL}${authApi}`
                const response = await this.httpLogin().post(url, data)
                console.debug('[AUTH][postLogin] RESPONSE', response.data)
                return response.data
        },
        async postLogout(data) {
                const url = `${baseURL}${authApi}/postLogout`
                const response = await this.httpSession().post(url, data)
                return response.data
        }
    },
    mixins: [SessionApi],
};
